import { useEffect, useState } from 'react';
import { faqService } from '../Model/Services/faqService.js';

export const useFaqItems = () => {
  const [items, setItems] = useState(() => faqService.getCached() ?? []);
  const [loading, setLoading] = useState(() => !faqService.getCached());
  const [error, setError] = useState(null);

  const fetchItems = async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await faqService.getAll();
      setItems(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchItems();
  }, []);

  const createFaq = async (payload) => {
    setError(null);
    const created = await faqService.create(payload);
    setItems((prev) => [...prev, created].sort((a, b) => a.sortOrder - b.sortOrder || a.id - b.id));
    return created;
  };

  const updateFaq = async (id, payload) => {
    setError(null);
    const updated = await faqService.update(id, payload);
    setItems((prev) =>
      prev
        .map((item) => (item.id === id ? updated : item))
        .sort((a, b) => a.sortOrder - b.sortOrder || a.id - b.id)
    );
    return updated;
  };

  const deleteFaq = async (id) => {
    setError(null);
    await faqService.delete(id);
    setItems((prev) => prev.filter((item) => item.id !== id));
  };

  return {
    items,
    loading,
    error,
    refresh: fetchItems,
    createFaq,
    updateFaq,
    deleteFaq,
  };
};
